// import './App.css';
// import './components/style.css'
import React from "react";
import AploadPaper from './paper_apload';
import Login from './login';
import {toast} from 'react-hot-toast';

import {BrowserRouter as Router, Link, Navigate, Route, Routes} from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import { Navbar, Nav, NavDropdown, Form, Button, ButtonGroup } from 'react-bootstrap';
import { Toaster } from 'react-hot-toast';
import { useEffect, useState } from 'react';
import authService from '../services/authService';
import Subscriptions from './subscriptions';
import Papers from './papers';


const NavbarComponet = ()=>{

    const [currentUser, setCurrentUser] = useState(undefined)
    useEffect(()=>{
      const user = authService.getCurrentUser()
      if(user){
        setCurrentUser(user)
      }
    }, [])
  
    const authButton = () => {
      if (!currentUser) {
          return (
              <ButtonGroup>
                  <Button variant="secondary" as={Link} to="/login">Login</Button>
              </ButtonGroup>
          )
              
      } else {
          return <Button variant="secondary" onClick={handleLogoutClick}>Logout</Button>
      }
	}
  
  const handleLogoutClick = () => {
    localStorage.removeItem("user");
    toast.success('Logout Successfully')
    window.location.href = '/login'
  }
  

    return(
        <React.Fragment>
            <Navbar collapseOnSelect expand="sm" bg="light" variant="light" className="mb-3">
            <Navbar.Brand as={Link} to="/login" className="mx-3">Easy Links</Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
                {currentUser &&(<Nav className="mr-auto">
                    <Nav.Link as={Link} to="/discover">Students</Nav.Link>
                    <NavDropdown title="Books" id="collasible-nav-dropdown">
                        <NavDropdown.Item as={Link} to="/addBook">Upload Book</NavDropdown.Item>
                    </NavDropdown>
                    <NavDropdown title="Papers" id="collasible-nav-dropdown">
                        <NavDropdown.Item as={Link} to="/papers">List Papers</NavDropdown.Item>
                        <NavDropdown.Item as={Link} to="/create">Upload Paper</NavDropdown.Item>
                    </NavDropdown>
                    <NavDropdown title="Subscriptions" id="collasible-nav-dropdown">
                        <NavDropdown.Item as={Link} to="/subscriptions">Subscriptions</NavDropdown.Item>
                        <NavDropdown.Item as={Link} to="/wishlist">Wishlist</NavDropdown.Item>
                    </NavDropdown>
                    <NavDropdown title="Mock" id="collasible-nav-dropdown">
                        <NavDropdown.Item as={Link} to="/mocks">Mocks</NavDropdown.Item>
                        <NavDropdown.Item as={Link} to="/add_mock">Add Mock</NavDropdown.Item>
                    </NavDropdown>
                </Nav>)}
            </Navbar.Collapse>
            <Form className="mx-3">
                {authButton()}
            </Form>
        </Navbar>
        </React.Fragment>
    )
}

export default NavbarComponet